import { createIcon } from '../icon'
import UserIconRedesign from '@/components/atoms/svg/UserIconRedesign'

export const UserIconRedesignDefault = createIcon(UserIconRedesign)
